import { render, staticRenderFns } from "./PacmanLoader.vue?vue&type=template&id=2fb29d49&scoped=true&"
import script from "./PacmanLoader.vue?vue&type=script&lang=js&"
export * from "./PacmanLoader.vue?vue&type=script&lang=js&"
import style0 from "./PacmanLoader.vue?vue&type=style&index=0&id=2fb29d49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb29d49",
  null
  
)

export default component.exports